import { Cesium3DTileset } from "cesium";
import { AttachablePluginInterface } from "./CesiumWrapper";
import { ActivatableToolInterface } from "./ActivatableToolInterface";
import EventEmitter, { EventEmitterInterface } from "./EventEmitter";
import FeatureRayPickerPlugin from "./FeatureRayPickerPlugin";
import SelectedElementPlugin from "./SelectedElementPlugin";
import TilesetPlugin, { TilesetFeature } from "./TilesetPlugin";

export default class SelectionToolPlugin
  implements AttachablePluginInterface, ActivatableToolInterface
{
  private _isActive = false;
  private _detachClickFeature: (() => void) | null = null;
  private _detachClickEmpty: (() => void) | null = null;

  private readonly _featureClickedEvent = new EventEmitter<
    TilesetFeature | Cesium3DTileset
  >();
  private readonly _emptyClickedEvent = new EventEmitter<void>();
  private readonly _deactivatedEvent = new EventEmitter<void>();

  /** Fires when a feature or tileset is clicked while the tool is active. Use for navigation. */
  get featureClickedEvent(): EventEmitterInterface<
    TilesetFeature | Cesium3DTileset
  > {
    return this._featureClickedEvent;
  }

  /** Fires when an empty space is clicked while the tool is active. Use for panel close navigation. */
  get emptyClickedEvent(): EventEmitterInterface<void> {
    return this._emptyClickedEvent;
  }

  /** Fires when the tool is deactivated (another tool takes focus). Use for panel close navigation. */
  get deactivatedEvent(): EventEmitterInterface<void> {
    return this._deactivatedEvent;
  }

  constructor(
    private readonly _featureRayPicker: FeatureRayPickerPlugin,
    private readonly _selectedElement: SelectedElementPlugin,
  ) {}

  setViewer(): void {}
  detachViewer(): void {}

  isActive(): boolean {
    return this._isActive;
  }

  activate(): void {
    this._isActive = true;

    this._detachClickFeature =
      this._featureRayPicker.leftClickFeatureEvent.addHandler((object) => {
        if (TilesetPlugin.isFeature(object)) {
          this._selectedElement.setSelectedFeature(object);
        } else {
          this._selectedElement.clearSelection();
        }
        this._featureClickedEvent.emit(object);
      });

    this._detachClickEmpty =
      this._featureRayPicker.leftClickEmptyEvent.addHandler(() => {
        this._selectedElement.clearSelection();
        this._emptyClickedEvent.emit();
      });
  }

  deactivate(): void {
    this._isActive = false;
    this._detachClickFeature?.();
    this._detachClickEmpty?.();
    this._detachClickFeature = null;
    this._detachClickEmpty = null;
    this._selectedElement.clearSelection();
    this._deactivatedEvent.emit();
  }
}
